@if (!isHidden) {
    <div>
        @if (dataSourceState$ | async; as dataSourceState) {
            @if (dataSourceState.loading) {
                {{ 'LOADING.DATA_SOURCE' | delayDisplay | translate }}
            } @else {
                <mat-radio-group
                    [formControl]="control"
                    class="ca-slot-inline-radio-group w-full"
                    [caLayout]="slot().layout"
                    [caLayoutGap]="0"
                    [attr.aria-label]="ariaLabel()"
                    [value]="value()"
                    (change)="onValueChange($event.value)"
                    (blur)="onTouched()"
                >
                    @for (item of dataSourceMapping || dataSourceState.dataSource.items; track item.value) {
                        @let tooltip = slot() | slotTooltip: item.value;
                        <mat-radio-button
                            [disableRipple]="true"
                            [value]="item.value"
                            class="ca-no-border-radio"
                            [ngClass]="{ 'ca-radio-tile-with-tooltip': tooltip && !isVisual }"
                        >
                            @let slotTitle = slot().titleKey | translationKey: slot().titleData : item.value;
                            <span>{{ slotTitle }}</span>
                            @if (tooltip) {
                                <ca-visual [tooltip]="tooltip"></ca-visual>
                            } @else if (isVisual) {
                                <ca-visual [slot]="slot()" [value]="item.value" [iconSize]="24"></ca-visual>
                            }
                        </mat-radio-button>
                    }
                </mat-radio-group>
                @if (isErrorMessage) {
                    <div class="ca-subscript relative">
                        <div class="absolute ca-error-message" @slideDown>
                            <ca-form-error-message>
                                {{ errorMessageTranslation!.key | translationKey: errorMessageTranslation!.data }}
                            </ca-form-error-message>
                        </div>
                    </div>
                }
            }
        }
    </div>
}
